import { render, staticRenderFns } from "./ClickBlocker.vue?vue&type=template&id=6b9beb72&scoped=true"
import script from "./ClickBlocker.vue?vue&type=script&lang=js"
export * from "./ClickBlocker.vue?vue&type=script&lang=js"
import style0 from "./ClickBlocker.vue?vue&type=style&index=0&id=6b9beb72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9beb72",
  null
  
)

export default component.exports